export default {
  reason: [
    {
      key: "required",
      message: "Anledning för nekande av konto är obligatoriskt.",
      id: "reasonRequired",
    },
  ],
};
